function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getCityListApi } from '@/api/public';
import { mapGetters } from 'vuex';
import { enterpriseEntInfoApi, entInfoUpdateApi } from '@/api/enterprise';
import { getToken } from '@/utils/auth';
import { uploader } from '@/utils/uploadCloud';
import { edit } from 'ace-builds';
export default {
  name: 'Index',
  filters: {
    filterStatus: function filterStatus(val) {
      var obj = {
        0: '禁用',
        1: '正常',
        2: '待缴费',
        3: '已过期'
      };
      return obj[val];
    }
  },
  props: {
    tabCur: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      ruleForm: {
        logo: '',
        enterprise_name: '',
        short_name: '',
        province: '',
        city: '',
        area: '',
        address: '',
        phone: '',
        lead: '',
        business_license: ''
      },
      rules: {
        enterprise_name: [{
          required: true,
          message: this.$t('setting.info.title1'),
          trigger: 'blur'
        }],
        short_name: [{
          required: true,
          message: '请填写企业简称',
          trigger: 'blur'
        }],
        address: [{
          required: true,
          message: this.$t('setting.info.title2'),
          trigger: 'blur'
        }],
        phone: [{
          required: true,
          message: this.$t('setting.info.title3'),
          trigger: 'blur'
        }]
      },
      pageData: {},
      upLoadData: {},
      cityData: [],
      cityVal: [],
      cityVals: [],
      enterprise_name: '',
      address: '',
      myHeaders: {
        authorization: 'Bearer ' + getToken()
      },
      uploadSize: 2,
      loading: false,
      isEdit: false
    };
  },
  computed: _objectSpread({}, mapGetters(['userInfo'])),
  created: function created() {
    this.getCitylist();
    this.getData();
  },
  methods: {
    // 获取城市列表
    getCitylist: function getCitylist() {
      var _this = this;
      getCityListApi().then(function (res) {
        _this.cityData = res.data;
      });
    },
    handleClick: function handleClick(number) {
      this.tabCur = number.index;
    },
    // 上传文件方法
    uploadServerLog: function uploadServerLog(params) {
      var _this2 = this;
      var file = params.file;
      var options = {
        way: 2,
        relation_type: '',
        relation_id: 0,
        eid: 0
      };
      uploader(file, 1, 2, options).then(function (res) {
        // 获取上传文件渲染页面
        if (res.name) {
          _this2.ruleForm.logo = res.url;
          _this2.userInfo.avatar = res.url;
          _this2.handleSubmit();
          _this2.$store.commit('user/SET_USERINFO', _this2.userInfo);
        }
      }).catch(function (err) {});
    },
    handleRemove: function handleRemove() {},
    handleExceed: function handleExceed() {},
    // 获取数据
    getData: function getData() {
      var _this3 = this;
      enterpriseEntInfoApi().then(function (_ref) {
        var data = _ref.data;
        _this3.pageData = data;
        _this3.cityVal = [data.province, data.city, data.area];
        _this3.cityVals = [data.province, data.city, data.area];
        _this3.enterprise_name = data.enterprise_name;
        _this3.address = data.address;
        _this3.ruleForm = {
          logo: data.logo,
          enterprise_name: data.enterprise_name,
          short_name: data.short_name,
          province: data.province,
          city: data.city,
          area: data.area,
          address: data.address,
          phone: data.phone,
          lead: data.lead,
          business_license: data.business_license
        };
      });
    },
    handleSubmit: function handleSubmit() {
      var _this4 = this;
      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          _this4.ruleForm.province = _this4.cityVal[0];
          _this4.ruleForm.city = _this4.cityVal[1];
          _this4.ruleForm.area = _this4.cityVal[2];
          _this4.loading = true;
          entInfoUpdateApi(_this4.ruleForm).then(function (res) {
            if (res.status == 200) {
              _this4.loading = false;
              _this4.isEdit = false;
              _this4.getCitylist();
              _this4.getData();
            }
          }).catch(function (error) {
            _this4.loading = false;
          });
        }
      });
    },
    onEdit: function onEdit() {
      this.isEdit = true;
    },
    onCancel: function onCancel() {
      this.isEdit = false;
    }
  }
};